import { ReactElement } from 'react';
import styles from './sso-link.module.scss';
import clsx from 'clsx';

type OnlySSOProps = {
  logo: ReactElement;
  text: string;
  className?: string;
  onClick: () => void;
  'data-testid'?: string;
};

export const SSOLink = ({ logo, text, className, onClick, 'data-testid': dataTestId }: OnlySSOProps) => {
  return (
    <button onClick={onClick} className={clsx(styles.ssoLink, className)} data-testid={dataTestId}>
      {logo} <span>{text}</span>
    </button>
  );
};
